import React, { useContext } from "react";
import { Button, Label } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { TestSetStatusEnum } from "../../../app/util/GeneralEnums";

const Step3 = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { testSetStatus, tesSetStatusApproved } = rootStore.companyStore;

  return (
    <div>
      <label>Confirma el estado del set de pruebas</label>
      <br />
      <br />
      <Button
        disabled={
          testSetStatus?.testSetStatus === TestSetStatusEnum.WaitForUserConfirm
            ? false
            : true
        }
        onClick={() => tesSetStatusApproved()}
        className="ui primary button"
        color="blue"
        type="submit"
        content="Confirmar"
      />
      {testSetStatus.testSetStatus === TestSetStatusEnum.Sucess && (
        <div>
          <br />
          <Label className="floatright" basic color="green">
            {
              "El set de pruebas ha finalizado de manera satisfactoria. Haz quedado habilitado en ambiente de producción"
            }
          </Label>
          <br />
        </div>
      )}
    </div>
  );
};

export default observer(Step3);
